module.exports = __webpack_public_path__ + "static/media/round-timer-03.cb3d3aa1.svg";